import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { getBuilderLabels } from '../i18n/builderLabels';
import { BUILDER_UI_LOCALES, DEFAULT_LOCALE } from '../i18n/locales';

const STORAGE_KEY = 'scorewidget_builder_ui_locale';

const BuilderLocaleContext = createContext({
  locale: DEFAULT_LOCALE,
  setLocale: () => {},
  t: (key) => key,
  locales: BUILDER_UI_LOCALES,
});

function readStoredLocale() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && BUILDER_UI_LOCALES.some((l) => l.id === stored)) return stored;
  } catch {
    /* private mode */
  }
  return DEFAULT_LOCALE;
}

export function BuilderLocaleProvider({ children }) {
  const [locale, setLocaleState] = useState(readStoredLocale);

  const setLocale = useCallback((next) => {
    setLocaleState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  }, []);

  const t = useMemo(() => getBuilderLabels(locale), [locale]);

  const value = useMemo(
    () => ({ locale, setLocale, t, locales: BUILDER_UI_LOCALES }),
    [locale, setLocale, t]
  );

  return (
    <BuilderLocaleContext.Provider value={value}>{children}</BuilderLocaleContext.Provider>
  );
}

export function useBuilderLocale() {
  return useContext(BuilderLocaleContext);
}

export function useBuilderLabels() {
  return useContext(BuilderLocaleContext).t;
}
